import React, { useState } from 'react';
import { Link } from "gatsby"
import styled from "styled-components";
import AriaModal from "react-aria-modal";
import Img from "gatsby-image";
import Case from '../templates/case';
import colors from "../styles/colors";
import Minimize from "./Minimize";

export default ({ title = "", tagline = "", cases = [] }) => {
  console.log(cases)
  const [selectedCase, setSelectedCase] = useState(false);
  const [animate, setAnimate] = useState("exit");

  const openCase = (e, sCase) => {
    e.preventDefault();
    setSelectedCase(sCase);
  };
  const closeCase = () => {
    setAnimate("exit");
    setTimeout(() => setSelectedCase(false), 300);
  };

  return (
    <Container>
      <Slider>
        <Card as="div" blank={true}>
          {title && <h2>{title}</h2>}
          {tagline && <p>{tagline}</p>}
        </Card>
        {
          cases.map((study) =>
            <Card to={study.fields.slug} key={study.id} onClick={e => openCase(e, study)}>
              <CardImage fluid={study.frontmatter.galleryImages[0].childImageSharp.fluid} />
              <CardText>
                <CardText className="h4">{study.frontmatter.title}</CardText>
              </CardText>
            </Card>
          )}
      </Slider>

      <AriaModal
        titleText="Read more post"
        onExit={() => closeCase()}
        onEnter={() => setAnimate("enter")}
        mounted={selectedCase}
        underlayClickExits={true}
        verticallyCenter={true}
        underlayColor={false}
        underlayClass={animate === "enter" ? "underlay -enter" : "underlay"}
      >
        <>
          <CloseButton animate={animate} onClick={() => closeCase()}>
            <span className="sr-only">Close</span>
            <Minimize />
          </CloseButton>
          <div>
            <Case
              study={selectedCase}
              inline={true}
              animate={animate} />
          </div>
        </>
      </AriaModal>
    </Container>
  )
}

const Container = styled.div`
  padding: 6rem 0 0 0;
  background-color: ${colors.offWhite07};
`

const Slider = styled.div`
  display: flex;
  overflow-y: visible;
  padding: 0 0 6rem 0;
  margin: 0;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar-track
  {
    background-color: ${colors.offWhite};
  }

  &::-webkit-scrollbar
  {
    width: 1rem;
    background-color: ${colors.offWhite};
  }

  &::-webkit-scrollbar-thumb
  {
    border-radius: .5rem;
    background-color: ${colors.brand};
  }

`;

const Card = styled(Link)`
  background-color: ${props => props.blank ? "transparent" : colors.white};
  padding: ${props => props.blank ? '0 5%' : '0'};
  border-radius: 0.3rem;
  box-shadow: 0px 5px 15px -10px ${props => props.blank ? "transparent" : colors.black};
  overflow: hidden;
  scroll-snap-align: start;
  flex-shrink: 0;
  max-width: ${props => props.blank ? "60%" : "70%"};
  width: 30rem;
  margin-right: 1rem;
  position: relative;
  text-decoration: none;
`

const CardImage = styled(Img)`
  height: 20rem;
  width: 100%;
`

const CardText = styled.p`
  padding: .5rem 1rem;
  margin: 0;
`

const CloseButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 50%;
  top: 1rem;
  margin-left: -1.5rem;
  background: ${colors.brand};
  color: ${colors.white};
  width: 3rem;
  height: 3rem;
  border-radius: 2.5rem;
  font-family: "Roboto Slab", serif;
  font-weight: 600;
  cursor: pointer;
  z-index: 1;
  border: 2px solid ${colors.oliveGreen};
  transition: all 0.3s ease;
  opacity: ${p => (p.animate === "enter" ? "1" : "0")};
  transform: translate3d(
    ${p => (p.animate === "enter" ? "0, 0, 0" : "0, -5rem, 0")}
  );
  :hover,
  :active,
  :focus {
    outline: none;
  }
`;